import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';

import { DelegateRequest } from 'api/delegateApi';
import UserSearchModal from 'components/admin/modal/UserSearchModal';
import ErrorMessage from 'components/widget/ErrorMessage';
import { User } from 'model/User';
import { customStyles } from 'util/styleUtil';

import { delegateSchema } from './resolver/delegateResolvers';

type DelegateRegisterModalProps = {
  isOpen: boolean;
  onSubmit: (formData: DelegateRequest) => void;
  onClose: () => void;
};

export default function DelegateRegisterModal({
  isOpen,
  onSubmit,
  onClose,
}: DelegateRegisterModalProps) {
  const { t } = useTranslation();

  const [isUserModalOpen, setIsUserModalOpen] = useState<boolean>(false);
  const onOpenUserSearchModal = () => {
    setIsUserModalOpen(true);
  };
  const onCloseUserSearchModal = () => {
    setIsUserModalOpen(false);
  };

  const {
    register,
    getValues,
    setValue,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<DelegateRequest>({
    defaultValues: {
      name: t('validation.selectUser'),
      startDate: format(new Date(), 'yyyy-MM-dd'),
      endDate: '',
    },
    resolver: delegateSchema,
  });

  useEffect(() => {
    if (isOpen) {
      reset({
        name: t('validation.selectUser'),
        startDate: format(new Date(), 'yyyy-MM-dd'),
        endDate: '',
      });
    }
  }, [isOpen]);

  const handleSelectUser = (user: User) => {
    setValue('name', user.name);
    setValue('agentId', user.userId);

    onCloseUserSearchModal();
  };

  return (
    <>
      <ReactModal isOpen={isOpen} style={customStyles} onRequestClose={onClose}>
        <div id={'popup-wrap'} className={'delegate-edit-modal'}>
          <div className={'popup-wrap'}>
            <div className={'popup-head'}>
              <p className={'poptit'}>{t('coop.delegateAndMandate')}</p>
            </div>
            <div className={'popup-cont'}>
              <div>
                <div className={'delegate-wrap'}>
                  <div className={'cont-wrap'}>
                    <div className={'box-wrap w100p'}>
                      <div className={'box'}>
                        <div className={'cont'}>
                          <table className={'tbl_hl01'}>
                            <tbody>
                              <tr>
                                <th>{t('coop.mandate-user')}</th>
                                <td className={'left'}>
                                  <div className={'flex-between'}>
                                    <span>{getValues('name')}</span>
                                    <button
                                      type={'button'}
                                      className={'orange_white_btn'}
                                      onClick={() => onOpenUserSearchModal()}
                                    >
                                      {t('button.set')}
                                    </button>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <th>{t('shift.startDate')}</th>
                                <td aria-label={'startDate'}>
                                  <input
                                    type={'hidden'}
                                    {...register('startDate')}
                                  />
                                  <p>{getValues('startDate')}</p>
                                  {/* <input
                                    type={'date'}
                                    min={format(new Date(), 'yyyy-MM-dd')}
                                    {...register('startDate')}
                                  /> */}
                                </td>
                              </tr>
                              <tr>
                                <th>{t('shift.endDate')}</th>
                                <td aria-label={'endDate'}>
                                  <input
                                    type={'date'}
                                    min={format(new Date(), 'yyyy-MM-dd')}
                                    {...register('endDate')}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ErrorMessage errors={errors} />
              <div className={'btn-wrap'}>
                <button
                  type={'button'}
                  className={'orange_white_btn'}
                  onClick={handleSubmit(onSubmit)}
                >
                  {t('button.regist')}
                </button>
                <button
                  type={'button'}
                  className={'gray_white_btn'}
                  onClick={onClose}
                >
                  {t('button.close')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
      {/* 사용자 검색 모달 */}
      <UserSearchModal
        isOpen={isUserModalOpen}
        onSelect={handleSelectUser}
        onClose={onCloseUserSearchModal}
      />
    </>
  );
}
